// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mock-exam-schedule-date svg,
.mock-exam-schedule-time svg {
  fill: currentColor;
}

p.mock-exam-student-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.mock-exam-schedule-checkbox-container .cb-label {
  display: none;
}

.mock-exam-schedule-checkbox-container > label {
  cursor: pointer;
}

.mock-exam-schedule-container.enrolled
  .mock-exam-schedule-checkbox-container
  > label,
.mock-exam-schedule-container.enrolled .mock-exam-schedule-desc {
  cursor: default;
}

.mock-exam-schedule-container.enrolled {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/mock_exam/BookSession.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".mock-exam-schedule-date svg,\n.mock-exam-schedule-time svg {\n  fill: currentColor;\n}\n\np.mock-exam-student-name {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.mock-exam-schedule-checkbox-container .cb-label {\n  display: none;\n}\n\n.mock-exam-schedule-checkbox-container > label {\n  cursor: pointer;\n}\n\n.mock-exam-schedule-container.enrolled\n  .mock-exam-schedule-checkbox-container\n  > label,\n.mock-exam-schedule-container.enrolled .mock-exam-schedule-desc {\n  cursor: default;\n}\n\n.mock-exam-schedule-container.enrolled {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
